import { ComponentParams, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps, TranslationOptionsParams } from 'src/shared/shared.types';

export type E02EventSearchProps = RenderingProps<E02EventSearchFields, E02EventSearchParams>;

export type E02EventSearchFields = {
  UUID?: Field<string>;
};

export type E02EventSearchParams = ComponentParams & TranslationOptionsParams;
